import {
  ListStyleType,
  someList,
  someTodoList,
  toggleList,
} from "@platejs/list";
import { List, ListOrdered, ListTodo } from "lucide-react";
import { useEditorRef, useEditorSelector } from "platejs/react";
import { memo } from "react";
import { ToolbarButton } from "./toolbar";

export const NumberedListToolbarButton = memo(
  function NumberedListToolbarButton() {
    const editor = useEditorRef();

    const pressed = useEditorSelector(
      (editor) =>
        someList(editor, [
          ListStyleType.Decimal,
          ListStyleType.LowerAlpha,
          ListStyleType.UpperAlpha,
          ListStyleType.LowerRoman,
          ListStyleType.UpperRoman,
        ]),
      [],
    );

    return (
      <ToolbarButton
        Icon={ListOrdered}
        onClick={() => {
          toggleList(editor, { listStyleType: ListStyleType.Decimal });
        }}
        pressed={pressed}
        tooltip="Numbered List"
      />
    );
  },
);

export const BulletedListToolbarButton = memo(
  function BulletedListToolbarButton() {
    const editor = useEditorRef();

    const pressed = useEditorSelector(
      (editor) =>
        someList(editor, [
          ListStyleType.Disc,
          ListStyleType.Circle,
          ListStyleType.Square,
        ]),
      [],
    );

    return (
      <ToolbarButton
        Icon={List}
        onClick={() => {
          toggleList(editor, { listStyleType: ListStyleType.Disc });
        }}
        pressed={pressed}
        tooltip="Bulleted List"
      />
    );
  },
);

export const TodoListToolbarButton = memo(function TodoListToolbarButton() {
  const editor = useEditorRef();

  const pressed = useEditorSelector((editor) => someTodoList(editor), []);

  return (
    <ToolbarButton
      Icon={ListTodo}
      onClick={() => {
        toggleList(editor, { listStyleType: "todo" });
      }}
      pressed={pressed}
      tooltip="Todo List"
    />
  );
});
